import { ISnowplowContext } from '@mindtickle/snowplow-client/lib/core/interfaces/tracker';
import { getUserContext } from '~/components/Snowplow/userContext';
import { getCompanyContext } from '~/components/Snowplow/companyContext';
import { TLocalAuthContext } from '~/components/Auth/types';

const getGlobalContextData = (
  user:
    | {
        id: string;
        name: string;
        email: string;
        sessionId: string;
        isWebView: string;
        locale?: string | undefined;
        freshchatRestoreId?: string | null | undefined;
        freshchatId?: string | undefined;
        isLoggedIn: boolean;
      }
    | undefined,
  company: TLocalAuthContext['company'] | undefined
) => {
  const globalContexts: (ISnowplowContext | (() => ISnowplowContext))[] = [];
  globalContexts.push(getUserContext(user));
  globalContexts.push(getCompanyContext(company));
  return globalContexts;
};

export default getGlobalContextData;
